import { Pagination } from "@mui/material";
import { MoreHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { checkTagValidity } from "../../Utils/Utils";
import { ADD_BATIMENT, DELETE_BATIMENT } from "../../Utils/constant";
import { Home } from "../../components/Icons/Home";
import { UpdateTypeBatimentForm } from "../../components/TypeBatiment/UpdateTypeBatimentForm";
import { Loader } from "../../components/Widget/Loader";
import { deleteOne, store } from "../../services/service";
import { useStoreBatiment } from "../../store/Paramettre/batimentStore";

export const TypeBatiment = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const batiments = useStoreBatiment();
  const [itemUpdate, setItemUpdate] = useState(null);

  useEffect(() => {
    batiments.batiments({ page: 0, param: "", size: 10 });
  }, []);

  const more = (page) =>
    batiments.batiments({ page: page - 1, param: "", size: 10 });

  const submit = (data) => {
    setIsSubmit(true);
    store(ADD_BATIMENT, "application/json", data)
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          batiments.batiments({ page: 0, param: "", size: 10 });
          document.getElementById("modal_add").close();
          toast.success("Type de bâtiment ajouté");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  const inputCls =
    "w-full h-10 px-3 border border-gray-200 rounded-lg text-sm text-gray-900 bg-gray-50 outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 transition";
  const closeBtnCls =
    "w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-500 text-sm font-semibold transition";

  return (
    <>
      {/* Header */}
      <div className="mt-4 mb-1">
        <p className="text-2xl font-bold text-gray-900 tracking-tight">
          Types de bâtiment
        </p>
        <p className="text-sm text-gray-400 mt-1">
          Gestion des types de bâtiments disponibles
        </p>
      </div>

      {/* Toolbar */}
      <div className="flex flex-wrap items-center gap-3 py-4 border-b border-gray-100 mb-6">
        <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 h-10">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#9ca3af"
            strokeWidth="2"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
          <input
            type="text"
            placeholder="Rechercher un type de bâtiment…"
            className="bg-transparent border-none outline-none text-sm text-gray-900 placeholder-gray-400 w-52"
          />
        </div>

        {checkTagValidity("AJOUTER_BATIMENT") && (
          <button
            onClick={() => {
              reset();
              document.getElementById("modal_add").showModal();
            }}
            className="ml-auto h-10 px-4 bg-yellow-400 hover:bg-yellow-300 text-gray-900 text-sm font-semibold rounded-xl transition"
          >
            + Ajouter
          </button>
        )}
      </div>

      {/* Add Modal */}
      <dialog id="modal_add" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-bold text-gray-900">
              Nouveau type de bâtiment
            </h2>
            <form method="dialog">
              <button className={closeBtnCls}>✕</button>
            </form>
          </div>
          <form onSubmit={handleSubmit(submit)} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Désignation <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className={inputCls}
                {...register("designation", { required: true })}
              />
              {errors.designation && (
                <p className="text-xs text-red-500 mt-1">
                  Ce champ est obligatoire
                </p>
              )}
            </div>
            <button
              type="submit"
              disabled={isSubmit}
              className={`w-full h-10 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 transition ${
                isSubmit
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-yellow-400 hover:bg-yellow-300 text-gray-900"
              }`}
            >
              {isSubmit ? (
                <>
                  <span className="loading loading-spinner loading-xs" />{" "}
                  Enregistrement…
                </>
              ) : (
                "Enregistrer"
              )}
            </button>
          </form>
        </div>
      </dialog>

      {/* Update Modal */}
      <dialog id="updateBat" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-bold text-gray-900">
              Modifier le type de bâtiment
            </h2>
            <form method="dialog">
              <button className={closeBtnCls}>✕</button>
            </form>
          </div>
          <UpdateTypeBatimentForm item={itemUpdate} />
        </div>
      </dialog>

      {/* Delete Modal */}
      <dialog id="delete_batiment" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <p className="text-base font-bold text-gray-900 mb-1">
            Confirmer la suppression
          </p>
          <p className="text-sm text-gray-500 mb-6">
            Le type{" "}
            <span className="font-semibold text-gray-800">
              {itemUpdate?.designation}
            </span>{" "}
            sera définitivement supprimé.
          </p>
          <div className="flex justify-end gap-2">
            <form method="dialog">
              <button className="h-9 px-4 rounded-lg text-sm font-medium bg-gray-100 hover:bg-gray-200 text-gray-700 transition">
                Annuler
              </button>
            </form>
            <form method="dialog">
              <button
                onClick={() => {
                  deleteOne(DELETE_BATIMENT, itemUpdate.id)
                    .then(() => {
                      batiments.batiments({ page: 0, param: "", size: 10 });
                      toast.success(`${itemUpdate.designation} supprimé`);
                    })
                    .catch(() => {});
                }}
                className="h-9 px-4 rounded-lg text-sm font-medium bg-red-500 hover:bg-red-600 text-white transition"
              >
                Supprimer
              </button>
            </form>
          </div>
        </div>
      </dialog>

      {/* Grid */}
      {batiments?.loading ? (
        <Loader />
      ) : batiments?.data?.batiments?.length === 0 ? (
        <div className="flex items-center justify-center h-48">
          <p className="text-sm text-gray-400">Aucun type de bâtiment trouvé</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3">
          {batiments?.data?.batiments?.map((item) => (
            <div
              key={item.id}
              className="relative bg-white border border-gray-200 rounded-xl p-3 flex items-center gap-3 hover:shadow-md hover:border-yellow-300 transition-all duration-200"
            >
              {/* Menu */}
              <div className="dropdown dropdown-end absolute top-2 right-2">
                <div
                  tabIndex={0}
                  role="button"
                  className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500 transition cursor-pointer"
                >
                  <MoreHorizontal size={15} />
                </div>
                <ul
                  tabIndex={0}
                  className="dropdown-content z-10 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg w-40 p-1.5"
                >
                  <li>
                    <button
                      className="w-full h-8 px-3 text-left text-xs font-medium text-gray-700 rounded-lg hover:bg-gray-50 transition"
                      onClick={() => {
                        setItemUpdate(item);
                        document.getElementById("updateBat").showModal();
                      }}
                    >
                      Modifier
                    </button>
                  </li>
                  <li>
                    <button
                      className="w-full h-8 px-3 text-left text-xs font-medium text-red-600 rounded-lg hover:bg-red-50 transition"
                      onClick={() => {
                        setItemUpdate(item);
                        document.getElementById("delete_batiment").showModal();
                      }}
                    >
                      Supprimer
                    </button>
                  </li>
                </ul>
              </div>

              {/* Icon */}
              <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center shrink-0 text-gray-500">
                <Home />
              </div>

              {/* Name */}
              <p className="text-xs font-semibold text-gray-900 truncate flex-1 pr-6">
                {item.designation}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Pagination */}
      <div className="flex justify-end mt-6">
        <Pagination
          onChange={(_, v) => more(v)}
          count={batiments.count}
          variant="outlined"
          color="primary"
          shape="rounded"
          size="small"
        />
      </div>
    </>
  );
};
